<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group class="row">
        <div class="col-4">
          {{ $t('integrations.users_table.queue_name') }}
        </div>
        <div class="col-8 pl-0 pr-25">
          <z-form-input :rules="{ required: true, max: 255 }">
            <i-input v-model="form.queue.name" disabled="disabled" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4">
          {{ $t('integrations.users_table.caller_id') }}
        </div>
        <div class="col-8 pl-0 pr-25">
          <z-form-input :rules="{ required: true, max: 255 }">
            <i-input v-model="form.caller_id" disabled="disabled" />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>

    <i-button slot="footer-ok" type="success" size="large" :loading="is_button_loading">
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';
  import { TrunkService } from '@voice/services/TrunkService';

  export default {
    components: {
      BaseModal
    },

    props: {
      id: {
        type: [Number, String],
        default: null
      },

      item: {
        type: Object,
        default: () => ({})
      },

      ip_disabled: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      form: {},
      is_button_loading: false
    }),

    watch: {
      item: {
        handler: function (val) {
          this.form = defaultsDeep(pick(val, ['caller_id', 'queue.name']), {
            caller_id: ''
          });
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_button_loading = true;
            const request = TrunkService.editItem(this.id, this.form);

            request
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                this.$noty.server_error(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  .pr-25 {
    padding-right: 25px !important;
  }

  .z-form-item {
    .main-ip__tooltip {
      .ivu-tooltip {
        position: absolute;
        top: 5px;
        right: -26px;

        &-popper {
          left: -130px !important;
        }

        &-arrow {
          left: 141px !important;
        }

        &-inner {
          width: 150px;
        }

        i {
          font-size: 21px;
        }
      }
    }
  }
</style>
